<template>
  <div class="header-form">
    <van-form ref="formRef" label-width="auto">
      <van-field
        :value="form.materialSupplier && form.templateName ? `${form.materialSupplier}-${form.templateName}` : ''"
        name="materialSupplier"
        label="领料单模板："
        placeholder="请选择对应模板"
        input-align="right"
        :right-icon="businessType === 'upload' ? 'arrow' : ''"
        class="field-required"
        style="margin-bottom: 8px;"
        readonly
        :rules="[{ required: true , message: '请选择领料单模板' , trigger: 'onChange' }]"
        @click="handleSelectTemplate"
      ></van-field>
      <van-field
        :value="form.tempAdded ? '是' : '否'"
        name="tempAdded"
        label="临时加料："
        placeholder="请选择是否临时加料"
        input-align="right"
        :right-icon="businessType === 'upload' ? 'arrow' : ''"
        class="field-required"
        style="margin-bottom: 8px;"
        readonly
        :rules="[{ required: true , type: 'boolean' , message: '请选择是否临时加料' , trigger: 'onChange' }]"
        @click="handleSelectTempAdded"
      ></van-field>
      <van-field
        value=""
        name="fileName"
        label="数据来源（领料单）："
        placeholder=""
        input-align="right"
        readonly
        v-if="businessType === 'generate'"
        style="color: #FFBD2D;"
      >
        <template #extra><span @click="handleViewDataSource" style="font-size: 14px;color: #FFBD2D;">点击查看</span></template>
      </van-field>
      <van-field
        v-if="form.materialSupplier && form.templateName && businessType === 'upload'"
        :value="form.fileName"
        name="fileName"
        label="上传领料单"
        placeholder=""
        input-align="right"
        class="field-required"
        readonly
        :rules="[{ required: true , message: '请上传领料单' , trigger: 'onChange' }]"
      ></van-field>
      <input 
        type="file" 
        id="uFile" 
        name="uFile" 
        style="display: none;" 
        @change="handleInputUpload($event)" 
      />
      <div class="file-group" v-if="materialFile && businessType === 'upload'">
				<div class="file-card">
					<div style="display: flex;align-items: center;margin-bottom: 12px;">
						<!-- <div class="file-icon"></div> -->
            <van-image
              width="36"
              height="40"
              :src="require('@/assets/image/filesIcon/excel-icon.png')"
              class="file-icon"
            />
						<div style="flex: 1;overflow: hidden;">
							<div class="file-name">
								<span class="single-line-hide">{{ splitFileName(materialFile.name).name }}</span>
								<span>.{{ splitFileName(materialFile.name).extension }}</span>
							</div>
							<div class="file-size">{{ fileSizeFormat(materialFile.size) }}</div>
						</div>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div class="file-date">{{ parseTime(materialFile.lastModified,"{y}-{m}-{d}") }}</div>
						<div>
							<div class="file-text-btn" style="color: #FF484A;" @click="fileRemove">删除</div>
						</div>
					</div>
				</div>
			</div>
      <div class="upload-button" @click="handleSelectFile" v-else-if="form.materialSupplier && form.templateName && businessType === 'upload'">
        <van-icon name="add-o" class="add-o" size="18px" />上传附件
      </div>
    </van-form>
    <div class="table-operation warning-count" v-if="businessType === 'generate' && abnormalData.warningMessageList && abnormalData.warningMessageList.length">
      <div style="display: flex;align-items: center;">
        <van-icon 
          name="warning" 
          size="12px"
          color="#FFC11B"
          style="margin-right: 8px;"
        />
        <div style="font-size: 12px;">本次导入任务存在重复物料编码<span style="color: #F6585A;"> {{ abnormalData.warningMessageList.length }} </span>处</div>
      </div>
      <div class="positioning-button" @click="tableWarningPosition">
        <i class="iconfont icon-positioning" style="font-size: 14px;margin-right: 2px;"></i>
        定位
      </div>
    </div>
    <div class="table-operation" v-if="businessType === 'generate'">
      <div class="manual-entry-button" @click="handleTableManualEntry">
        <van-icon name="plus" size="12px" color="#FFBD2D" style="margin-right: 4px;" />
        手动录入
      </div>
      <div style="display: inline-flex;align-items: center;font-size: 12px;">
        <div>导入<span style="color: #EC892E;"> {{ abnormalData.total }} </span>条数据，识别<span style="color: #F6585A;"> {{ abnormalData.errorMessageList && abnormalData.errorMessageList.length }} </span>处异常</div>
        <div class="positioning-button" @click="tableAbnormalPosition">
          <i class="iconfont icon-positioning" style="font-size: 14px;margin-right: 2px;"></i>
          定位
        </div>
      </div>
    </div>
    <action-sheet ref="actionSheetRef" />
    <data-source-popup ref="dataSourcePopupRef" />
  </div>
</template>

<script>
import { getMaterialSupplierList , getTemplateList } from "@/api/material/materialDataUpload/index.js";
import { splitFileName , fileSizeFormat , parseTime } from "@/utils/index.js";
import { Form , Field , Button , Icon , Image as VanImage } from "vant";
import dataSourcePopup from "./data-source-popup.vue";
import actionSheet from "./action-sheet.vue";
export default {
  components:{
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    actionSheet,
    dataSourcePopup
  },
  inject:["tableAbnormalPosition","getTableData","tableWarningPosition"],
  props:["businessType","abnormalData"],
  data(){
    return {
      form: {
        materialSupplier: "",
        materialTemplate: "",
        fileName: "",
        tempAdded: false,
      },
      materialFile: null,
      templateActive: {},
      tableDataInfo:{
        total: 0,
        errorAbnormal: 0,
        warningAbnormal: 0,
      },
    }
  },
  mounted(){
    this.$emit("getHeaderFormHeight");
  },
  methods: {
    splitFileName,
    fileSizeFormat,
    parseTime,
    async validate(){
      try {
        await this.$refs.formRef.validate();
        console.log("校验通过");
        return Promise.resolve(true);
      } catch (error) {
        console.log("valid error",error);
        this.$toast({
          type: "html",
          message: `
            <div style="display: flex;align-items: center;">
              <i class="iconfont icon-toast-error" style="font-size: 22px;color: #FF484A;margin-right: 6px;"></i>
              <div style="font-size: 14px;line-height: 22px;white-space: nowrap;">${error[0].message}</div>
            </div>
          `,
          position: "top",
          className: "material-data-upload-toast",
          getContainer: "body"
        })
        return Promise.reject(error);
      }
    },
    // 查看数据来源
    handleViewDataSource(){
      this.$refs.dataSourcePopupRef.init({
        materialFile: this.materialFile ,
      })
    },
    // 选择文件
    handleSelectFile(){
      document.querySelector("#uFile").click();
    },
    handleInputUpload(e){
      let file = e.target.files[0];
      if(!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')){
        this.$dialog.alert({
          message: "不支持的文件格式，请选择.xlsx或.xls格式的Excel文件",
          allowHtml:false,
          confirmButtonColor:'#EC892E'
        });
        return;
      };
      this.$set(this.form,"fileName",file.name);
      this.materialFile = file;
      document.querySelector("#uFile").value = "";
    },
    // 选择是否加料
    async handleSelectTempAdded(){
      try {
        let { value } = await this.$refs.actionSheetRef.init({
          list: [
            { name: "是" , value: true },
            { name: "否" , value: false }
          ],
          cancelText: "取消"
        });
        this.$set(this.form,"tempAdded",value);
        await this.nextTick();
        this.$emit("getHeaderFormHeight");
        return Promise.resolve(true);
      } catch (error) {
        console.log("handleSelectTemplate error",error);
        return Promise.reject(error);
      }
    },
    // 选择模板
    async handleSelectTemplate(){
      try {
        if(this.businessType === "generate") return;
        this.$loading.open();
        // 获取供应商列表
        let { rows: companyList } = await this.getMaterialSupplierList();
        console.log("companyList",companyList)
        // 选择供应商
        let { name: materialSupplier , id: materialSupplierId } = await this.$refs.actionSheetRef.init({
          list: companyList,
          description: "请选择上传领料数据供应商",
          cancelText: "取消"
        });
        this.$loading.open();
        await this.$sleep(500);
        // 获取供应商模板列表
        let { rows: templateList } = await this.getTemplateList(materialSupplierId);
        // 选择供应商模板
        this.templateActive = await this.$refs.actionSheetRef.init({
          list: templateList,
          description: "请选择供应商模板",
          cancelText: "取消"
        });
        let { name: templateName , id: templateId } = this.templateActive;
        this.form = {
          ...this.form,
          materialSupplier,
          materialSupplierId,
          templateName,
          templateId
        };
        await this.nextTick();
        this.$emit("getHeaderFormHeight");
        return Promise.resolve(true);
      } catch (error) {
        console.log("handleSelectTemplate error",error);
        return Promise.reject(error);
      }
    },
    nextTick(){
      return new Promise((resolve) => {
        this.$nextTick(() => {
          resolve();
        })
      })
    },
    // 获取供应商列表
    getMaterialSupplierList(){
      return getMaterialSupplierList({
        params: {
          pageNum: 1,
          pageSize: 10
        },
        data: {}
      });
    },
    // 获取供应商模板
    getTemplateList(materialSupplierId){
      return getTemplateList({
        params: {
          pageNum: 1,
          pageSize: 10
        },
        data: {
          materialSupplierId
        }
      });
    },
    async fileRemove(){
      await this.$dialog.confirm({
        title: "是否删除领料单",
        message: "删除后文件不可找回，请注意备份",
        className: "confirm-dialog--warning",
      });
      this.$set(this.form,"fileName","");
      this.materialFile = null;
    },
    // 手动录入
    handleTableManualEntry(){
      /* this.$bus.emit("materialDataFormSubmit",{
        "materialSupplier": "华为",
        "serialNumber": "53",
        "materialCode": "HQ111B0645009",
        "issueNumber": "2322",
        "issueTime": "2025-03-26",
        "materialWarehouse": "华为 嘉达 三号楼一",
        "deliveryLocation": "VIVO 新仓 一号库",
        "workCenter": "D2195",
        "materialType": "QC",
        "materialDescription": "套片IC MT6631N/B QFN",
        "remark": "王德发"
      }); */
      let tableData = this.getTableData();
      this.$store.commit("DATA_UPLOAD_ADD_EDIT_QUERY",{
        form: {
          materialSupplier: this.form.materialSupplier,
          serialNumber: tableData.length + 1,
        }
      })
      this.$router.push({
        path: "/material/materialDataUpload/addEdit",
        query: {
          AES: this.$route.query.AES,
        }, 
      })
    }
  }
}
</script>



<style scoped lang="scss">
  .header-form{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 999;
    background-color: #FFF;
    .van-cell {
      font-size: 14px;
      line-height: 22px;
      padding: 12px 28px;
    }
    .field-required {
      ::v-deep .van-field__label {
        position: relative;
        &:before {
          content: '*';
          position: absolute;
          left: -10px;
          top: -4px;
          z-index: 1;
          color: #FF3838;
        }
      }
    }
    .upload-button {
      height: 82px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #EC892E;
      background-color: #FFF;
      margin-bottom: 16px;
      .add-o {
        margin-right: 8px;
        color: #EC892E;
        font-weight: bold;
      }
      &:active {
        opacity: .7;
      }
    }
    .file-group {
			padding: 16px 12px 16px 28px;
			background-color: #FFF;
			// border-top: 1px solid #EFF0F4;
			.file-card {
				border: 1px solid #EFEFEF;
				border-radius: 4px;
				overflow: hidden;
				padding: 16px;
				.file-icon {
					margin-right: 11px;
					flex-shrink: 0;
				}
				.file-name {
					font-size: 16x;
					line-height: 24px;
					font-weight: bold;
					color: #3D3833;
					display: flex;
					align-items: center;
				}
				.file-size {
					font-size: 12px;
					line-height: 20px;
					color: #85807B;
				}
				.file-date {
					font-size: 12px;
					line-height: 20px;
					color: #85807B;
				}
				.file-text-btn + .file-text-btn {
					margin-left: 8px;
				}
				.file-text-btn {
					font-size: 12px;
					line-height: 20px;
					display: inline-block;
				}
				.single-line-hide {
					overflow:hidden;
				    text-overflow:ellipsis;
				    white-space:nowrap;
				}
			}
		}
    .table-operation {
      height: 40px;
      display: flex;
      align-items: center;
      background-color: #F8F8F8;
      padding: 0 12px;
      justify-content: space-between;
      box-sizing: border-box;
      .manual-entry-button {
        height: 24px;
        border-radius: 20px;
        overflow: hidden;
        background-color: #3D3833;
        font-size: 12px;
        line-height: 24px;
        color: #FFBD2D;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        &:active {
          opacity:.7;
        }
      }
      .positioning-button {
        display: flex;
        align-items: center;
        color: #669EE6;
        margin-left: 8px;
        font-size: 12px;
        line-height: 14px;
        &:active {
          opacity: .7;
        }
      }
    }
    .table-operation.warning-count {
      height: 30px;
      background-color: #FFF7E7;
    }
    ::v-deep .van-field__right-icon {
      color: #C9C2BB;
      font-size: 14px;
    }
    ::v-deep .van-field__error-message {
      display: none;
    }
    
  }
  
</style>